import { Record } from 'immutable';
import CompanyTypeConstants from '~/constants/company-type-constants';

const keys: Fields = {
  inviteRequestId: '',
  company: '',
  firstName: '',
  lastName: '',
  email: '',
  contactNumber: '',
  creationDate: '',
  status: '',
  companyType: CompanyTypeConstants.UNDEFINED,
  approvable: false,
  rejectable: false,
};

interface Fields {
  inviteRequestId: string;
  company: string;
  firstName: string;
  lastName: string;
  email: string;
  contactNumber: string;
  creationDate: string;
  status: string;
  companyType: CompanyTypeConstants;
  approvable: boolean;
  rejectable: boolean;
}

export default class InviteRequestListItemRecord extends Record<Fields>(keys) {}
